import ufeApi from 'services/api/ufeApi';

function getRougeRewards(_token, profileLanguage, profileLocale) {
    const url = `/gway/productgraph/v5/bi/rewards?ch=rwd&loc=${profileLanguage}-${profileLocale ?? 'en-US'}&biExclusiveLevel=ROUGE`;

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default getRougeRewards;
